import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog } from '@fortawesome/free-solid-svg-icons'

import InputField     from 'src/components/InputField'
import useValidation  from './useValidation'

const ThankYouInfo = ({ i18n, thankYouInfo, donationsPath, donation }) => {
  const [ status, setStatus ] = useState('')
  const [ info, setInfo ] = useState('')
  const validation = useValidation({
    i18n,
    fieldSet: { info: { required: true, maxLength: 500 } },
  })

  const handleChange = e => setInfo(e.target.value)

  const submitInfo = () => {
    if (status && status != 'failed') return

    const url = [ donationsPath, donation.token ].join('/')

    const params = { order: { udf_label: thankYouInfo.label, udf_value: info } }

    setStatus('processing')

    fetch(url, {
      method: 'PATCH',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params)
    }).then(response => {
      if (response.ok)
        setStatus('sent')
      else
        setStatus('failed')
    }).catch(error => {
      setStatus('failed')
      console.error(error)
    })
  }

  const handleSubmit = e => {
    e.preventDefault()
    if (validation.validate({ info }))
      submitInfo()
  }

  return (
    <form
      className="thankyou bg-light px-3 py-4 px-sm-4 py-sm-5 rounded-4"
      onSubmit={handleSubmit}
      noValidate
    >
      <div className="thankyou-inner mb-n3 mx-auto" style={{ maxWidth: '30rem' }}>
        {
          thankYouInfo.heading &&
          <h2 className="h5 mt-1 mb-3">{thankYouInfo.heading}</h2>
        }

        {thankYouInfo.intro && <p>{thankYouInfo.intro}</p>}

        {
          status == 'sent'
        ? <div className="alert alert-success">
            {thankYouInfo.message || 'Thank you!'}
          </div>
        : <div>
            <InputField
              id="info"
              type={thankYouInfo.type}
              label={thankYouInfo.label}
              value={info}
              errors={validation.errors}
              onChange={handleChange}
              className={
                thankYouInfo.type == 'select'
                ? 'form-select w-auto mw-100'
                : 'form-control'
              }
              options={
                thankYouInfo.type == 'select'
                ? [{
                    label: 'Please choose one',
                    disabled: true,
                    value: '',
                  }].concat(thankYouInfo.options?.split(/\r?\n/) || [])
                : null
              }
            />
            <div className="mb-3">
              <button className="btn btn-primary"
                disabled={status == 'processing'}>
                {(() => {
                  switch (status) {
                    case 'failed':
                      return i18n.t('ajax_error')
                    case 'processing':
                      return (
                        <span>
                          <FontAwesomeIcon icon={faCog} spin className="mr-2" />
                          {i18n.t('submitting')}
                        </span>
                      )
                    default:
                      return thankYouInfo.submit || i18n.t('submit')
                  }
                })()}
              </button>
            </div>
          </div>
        }
      </div>
    </form>
  )
}

export default ThankYouInfo
